<div seds-avatar [class]="getClassCssAvatar()" [attr.title]="text">
  <img *ngIf="avatarImage" [src]="avatarImage" alt="Image Avatar" />
  <div *ngIf="!avatarImage && initials" [innerHTML]="initials"></div>
  <div *ngIf="!avatarImage && !initials" class="seds-avatar-icon-class">person</div>
</div>
